import {TableColumnsType, Tooltip} from 'antd';
import moment from 'moment';

import { AIRPORT_TITLES, DataType, TITLES } from '../types/GridTypes';
import { renderWithIcon } from '../utils/GridUtils';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import React from "react";

export const FlightColumns: TableColumnsType<DataType> = [
  {
    title: <div style={{
      textAlign: 'center',
      fontSize: 'medium',
      color: '#1e4876'
    }}>
      <strong>{TITLES.CLIENT}</strong>

    </div>,
    dataIndex: TITLES.CLIENT,
    key: '1',
    width: 150,
    align: 'center',
    sorter: (a, b) => a[TITLES.CLIENT].localeCompare(b[TITLES.CLIENT]),
    render: (text: string) => (
        <div style={{
          textAlign: 'center',
          fontSize: 'medium',
          color: '#1e4876'
        }}>
          <strong>{text}</strong>

        </div>
    ),
  },
  {
    title: TITLES.FLIGHT_NAME,
    dataIndex: TITLES.FLIGHT_NAME,
    key: '2',
    width: 105,
    align: 'center',
    sorter: (a, b) =>
        a[TITLES.FLIGHT_NAME].localeCompare(b[TITLES.FLIGHT_NAME]),
  },
  {
    title: 'Flight_ID',
    dataIndex: 'Flight ID',
    key: '39',
    align: 'center',
    width: 100,
    sorter: (a, b) => a['Flight ID'].localeCompare(b['Flight ID']),
  },
  {
    title: TITLES.ORIGIN_AIRPORT,
    dataIndex: TITLES.ORIGIN_AIRPORT,
    key: '3',
    hidden: true,
    width: 140,
    align: 'center',
    sorter: (a, b) =>
      a[TITLES.ORIGIN_AIRPORT].localeCompare(b[TITLES.ORIGIN_AIRPORT]),
  },
  {
    title: TITLES.DESTINATION_AIRPORT,
    dataIndex: TITLES.DESTINATION_AIRPORT,
    key: '4',
    align: 'center',
    sorter: (a, b) =>
      a[TITLES.DESTINATION_AIRPORT].localeCompare(
        b[TITLES.DESTINATION_AIRPORT],
      ),
  },
  {
    title: TITLES.MY_PRICE,
    dataIndex: TITLES.MY_PRICE,
    key: '16',
    align: 'center',
    sorter: (a, b) =>
        parseFloat(a[TITLES.MY_PRICE]) - parseFloat(b[TITLES.MY_PRICE]) > 0
            ? 1
            : -1,
  },
  {
    title: TITLES.PRICE_VS_MARKET,
    dataIndex: TITLES.PRICE_VS_MARKET,
    align: 'center',
    key: '21',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.ORIGIN_CITY,
    dataIndex: TITLES.ORIGIN_CITY,
    key: '5',
    hidden: true,
    align: 'center',
    sorter: (a, b) =>
      a[TITLES.ORIGIN_CITY].localeCompare(b[TITLES.ORIGIN_CITY]),
  },
  {
    title: TITLES.DESTINATION_CITY,
    dataIndex: TITLES.DESTINATION_CITY,
    key: '6',
    hidden: true,
    align: 'center',
    sorter: (a, b) =>
      a[TITLES.DESTINATION_CITY].localeCompare(b[TITLES.DESTINATION_CITY]),
  },
  {
    title: TITLES.ORIGIN_COUNTRY,
    dataIndex: TITLES.ORIGIN_COUNTRY,
    key: '7',
    hidden: true,
    align: 'center',
    sorter: (a, b) =>
      a[TITLES.ORIGIN_COUNTRY].localeCompare(b[TITLES.ORIGIN_COUNTRY]),
  },
  {
    title: TITLES.DESTINATION_COUNTRY,
    dataIndex: TITLES.DESTINATION_COUNTRY,
    key: '8',
    hidden: true,
    align: 'center',
    sorter: (a, b) =>
      a[TITLES.DESTINATION_COUNTRY].localeCompare(
        b[TITLES.DESTINATION_COUNTRY],
      ),
  },

  {
    title: TITLES.FLIGHT_DUE_DATE,
    dataIndex: TITLES.FLIGHT_DUE_DATE,
    key: '10',
    align: 'center',
    sorter: (a, b) => {
      const dateA = convertToDate(a[TITLES.FLIGHT_DUE_DATE]);
      const dateB = convertToDate(b[TITLES.FLIGHT_DUE_DATE]);

      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
      return 0;
    },
  },
  {
    title: TITLES.DEPARTURE_TIME,
    dataIndex: TITLES.DEPARTURE_TIME,
    key: '11',
    align: 'center',
    sorter: (a, b) => {
      // Parse the times using moment
      const timeA = moment(a[TITLES.DEPARTURE_TIME], 'h:mm a');
      const timeB = moment(b[TITLES.DEPARTURE_TIME], 'h:mm a');

      // Compare the times
      if (timeA.isBefore(timeB)) return -1;
      if (timeA.isAfter(timeB)) return 1;
      return 0;
    },
  },
  {
    title: TITLES.ARRIVAL_TIME,
    dataIndex: TITLES.ARRIVAL_TIME,
    key: '12',
    align: 'center',
    sorter: (a, b) => {
      // Parse the times using moment
      const timeA = moment(a[TITLES.DEPARTURE_TIME], 'h:mm a');
      const timeB = moment(b[TITLES.DEPARTURE_TIME], 'h:mm a');

      // Compare the times
      if (timeA.isBefore(timeB)) return -1;
      if (timeA.isAfter(timeB)) return 1;
      return 0;
    },
  },
  {
    title: TITLES.FLIGHT_DURATION,
    dataIndex: TITLES.FLIGHT_DURATION,
    key: '13',
    align: 'center',
    sorter: (a, b) => {
      // Convert the time strings to minutes
      const timeA = convertToMinutes(a[TITLES.FLIGHT_DURATION]);
      const timeB = convertToMinutes(b[TITLES.FLIGHT_DURATION]);

      // Compare the times
      if (timeA < timeB) return -1;
      if (timeA > timeB) return 1;
      return 0;
    },
  },
  {
    title: TITLES.FLIGHT_DATE_FINISH,
    dataIndex: TITLES.FLIGHT_DATE_FINISH,
    key: '15',
    hidden: true,
    align: 'center',
    sorter: (a, b) => {
      // Convert the date strings to Date objects
      const dateA = convertToDate(a[TITLES.FLIGHT_DUE_DATE]);
      const dateB = convertToDate(b[TITLES.FLIGHT_DUE_DATE]);

      // Compare the dates
      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
      return 0;
    },
  },
  {
    title: TITLES.CABIN_BAGGAGE_PRICE,
    dataIndex: TITLES.CABIN_BAGGAGE_PRICE,
    key: '18',
    hidden: true,
    align: 'center',
  },
  {
    title: TITLES.CHECKED_BAGGAGE_PRICE,
    dataIndex: TITLES.CHECKED_BAGGAGE_PRICE,
    key: '19',
    hidden: true,
    align: 'center',
  },
  {
    title: TITLES.AIRCRAFT,
    dataIndex: TITLES.AIRCRAFT,
    key: '20',
    hidden: true,
    align: 'center',
  },

  {
    title: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    dataIndex: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    align: 'center',
    key: '22',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_WIZZ_AIR,
    dataIndex: TITLES.PRICE_VS_WIZZ_AIR,
    align: 'center',
    key: '23',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_EASY_JET,
    dataIndex: TITLES.PRICE_VS_EASY_JET,
    align: 'center',
    key: '24',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.MARKET_PRICE_AVG,
    dataIndex: TITLES.MARKET_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
        <ExclamationCircleOutlined />
      </Tooltip>
    }

  },
  {
    title: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    dataIndex: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BLUE_AIR_PRICE_AVG,
    dataIndex: TITLES.BLUE_AIR_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.WIZZ_AIR_PRICE_AVG,
    dataIndex: TITLES.WIZZ_AIR_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.RYANAIR_PRICE_AVG,
    dataIndex: TITLES.RYANAIR_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.EASY_JET_PRICE_AVG,
    dataIndex: TITLES.EASY_JET_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.ARRIVAL_TYPE,
    dataIndex: TITLES.ARRIVAL_TYPE,
    key: '14',
    align: 'center',
    sorter: (a, b) =>
      a[TITLES.ARRIVAL_TYPE].localeCompare(b[TITLES.ARRIVAL_TYPE]),
  },
  {
    title: TITLES.LAST_SCAN,
    dataIndex: TITLES.LAST_SCAN,
    key: '17',
    align: 'center',
    sorter: (a, b) => {
      // Convert the date strings to Date objects
      const dateA = convertToDate(a[TITLES.FLIGHT_DUE_DATE]);
      const dateB = convertToDate(b[TITLES.FLIGHT_DUE_DATE]);

      // Compare the dates
      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
      return 0;
    },
  },
];

export const AirportColumns: TableColumnsType<DataType> = [
  {
    title: <div style={{
      textAlign: 'center',
      fontSize: 'medium',
      color: '#1e4876'
    }}>
      <strong>{TITLES.DESTINATION_AIRPORT}</strong>

    </div>,
    dataIndex: AIRPORT_TITLES.DESTINATION_AIRPORT,
    key: '1',
    width: 220,
    align: 'center',
    sorter: (a, b) =>
        a[AIRPORT_TITLES.DESTINATION_AIRPORT].localeCompare(
            b[AIRPORT_TITLES.DESTINATION_AIRPORT],
        ),
    render: (text: string) => (
        <div style={{
          textAlign: 'center',
          fontSize: 'medium',
          color: '#1e4876'
        }}>
          <strong>{text}</strong>

        </div>
    ),
  },
  {
    title: AIRPORT_TITLES.DESTINATION_CITY,
    dataIndex: AIRPORT_TITLES.DESTINATION_CITY,
    key: '2',
    width: 140,
    align: 'center',
    sorter: (a, b) =>
      a[AIRPORT_TITLES.DESTINATION_CITY].localeCompare(
        b[AIRPORT_TITLES.DESTINATION_CITY],
      ),
  },
  {
    title: AIRPORT_TITLES.FLIGHTS,
    dataIndex: AIRPORT_TITLES.FLIGHTS,
    key: '4',
    align: 'center',
    width: 120,
    sorter: (a: any, b: any) =>
      parseInt(a[AIRPORT_TITLES.FLIGHTS]) - parseInt(b[AIRPORT_TITLES.FLIGHTS]),
  },
  {
    title: TITLES.PRICE_DIFFERENCE,
    dataIndex: TITLES.PRICE_DIFFERENCE,
    width: 120,

    align: 'center',
    key: '29',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }
  },
  {
    title: TITLES.PRICE_VS_MARKET,
    dataIndex: TITLES.PRICE_VS_MARKET,
    align: 'center',
    key: '21',
    width: 120,
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    dataIndex: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    align: 'center',
    key: '22',
    width: 180,

    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_WIZZ_AIR,
    dataIndex: TITLES.PRICE_VS_WIZZ_AIR,
    align: 'center',
    key: '23',
    width: 180,
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_EASY_JET,
    dataIndex: TITLES.PRICE_VS_EASY_JET,
    align: 'center',
    key: '24',
    width: 180,

    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.MARKET_PRICE_AVG,
    dataIndex: TITLES.MARKET_PRICE_AVG,
    align: 'center',
    width:100,
    key: '25',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    dataIndex: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    align: 'center',
    width:100,
    key: '26',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BLUE_AIR_PRICE_AVG,
    dataIndex: TITLES.BLUE_AIR_PRICE_AVG,
    align: 'center',
    width:100,

    key: '27',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.WIZZ_AIR_PRICE_AVG,
    dataIndex: TITLES.WIZZ_AIR_PRICE_AVG,
    align: 'center',
    width:100,
    key: '28',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.RYANAIR_PRICE_AVG,
    dataIndex: TITLES.RYANAIR_PRICE_AVG,
    align: 'center',
    width:100,

    key: '29',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.EASY_JET_PRICE_AVG,
    dataIndex: TITLES.EASY_JET_PRICE_AVG,
    align: 'center',
    width:100,

    key: '30',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
];

export const DestCityColumns: TableColumnsType<DataType> = [
  {
    title: <div style={{
      textAlign: 'center',
      fontSize: 'medium',
      color: '#1e4876'
    }}>
      <strong>{AIRPORT_TITLES.DESTINATION_CITY}</strong>

    </div>,
    dataIndex: AIRPORT_TITLES.DESTINATION_CITY,
    key: '2',
    width: 140,
    align: 'center',
    sorter: (a, b) =>
        a[AIRPORT_TITLES.DESTINATION_CITY].localeCompare(
            b[AIRPORT_TITLES.DESTINATION_CITY],
        ),
    render: (text: string) => (
        <div style={{
          textAlign: 'center',
          fontSize: 'medium',
          color: '#1e4876'
        }}>
          <strong>{text}</strong>
        </div>
    )
  },
  {
    title: AIRPORT_TITLES.FLIGHTS,
    dataIndex: AIRPORT_TITLES.FLIGHTS,
    key: '4',
    align: 'center',
    width: 120,
    sorter: (a: any, b: any) =>
        parseInt(a[AIRPORT_TITLES.FLIGHTS]) - parseInt(b[AIRPORT_TITLES.FLIGHTS]),
  },
  {
    title: TITLES.PRICE_DIFFERENCE,
    dataIndex: TITLES.PRICE_DIFFERENCE,
    width: 120,

    align: 'center',
    key: '29',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }
  },
  {
    title: TITLES.PRICE_VS_MARKET,
    dataIndex: TITLES.PRICE_VS_MARKET,
    align: 'center',
    key: '21',
    width: 120,
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    dataIndex: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    align: 'center',
    key: '22',
    width: 180,

    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_WIZZ_AIR,
    dataIndex: TITLES.PRICE_VS_WIZZ_AIR,
    align: 'center',
    key: '23',
    width: 180,
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_EASY_JET,
    dataIndex: TITLES.PRICE_VS_EASY_JET,
    align: 'center',
    key: '24',
    width: 180,

    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.MARKET_PRICE_AVG,
    dataIndex: TITLES.MARKET_PRICE_AVG,
    align: 'center',
    width:100,
    key: '25',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    dataIndex: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    align: 'center',
    width:100,
    key: '26',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BLUE_AIR_PRICE_AVG,
    dataIndex: TITLES.BLUE_AIR_PRICE_AVG,
    align: 'center',
    width:100,

    key: '27',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.WIZZ_AIR_PRICE_AVG,
    dataIndex: TITLES.WIZZ_AIR_PRICE_AVG,
    align: 'center',
    width:100,
    key: '28',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.RYANAIR_PRICE_AVG,
    dataIndex: TITLES.RYANAIR_PRICE_AVG,
    align: 'center',
    width:100,

    key: '29',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.EASY_JET_PRICE_AVG,
    dataIndex: TITLES.EASY_JET_PRICE_AVG,
    align: 'center',
    width:100,

    key: '30',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
];

export const DestCountryColumns: TableColumnsType<DataType> = [
  {
    title: <div style={{
      textAlign: 'center',
      fontSize: 'medium',
      color: '#1e4876'
    }}>
      <strong>{AIRPORT_TITLES.DESTINATION_COUNTRY}</strong>

    </div>,
    dataIndex: AIRPORT_TITLES.DESTINATION_COUNTRY,
    key: '2',
    width: 140,
    align: 'center',
    sorter: (a, b) =>
        a[AIRPORT_TITLES.DESTINATION_COUNTRY].localeCompare(
            b[AIRPORT_TITLES.DESTINATION_COUNTRY],
        ),
    render: (text: string) => (
        <div style={{
          textAlign: 'center',
          fontSize: 'medium',
          color: '#1e4876'
        }}>
          <strong>{text}</strong>

        </div>
    ),
  },
  {
    title: AIRPORT_TITLES.FLIGHTS,
    dataIndex: AIRPORT_TITLES.FLIGHTS,
    key: '4',
    align: 'center',
    width: 120,
    sorter: (a: any, b: any) =>
    parseInt(a[AIRPORT_TITLES.FLIGHTS]) - parseInt(b[AIRPORT_TITLES.FLIGHTS]),
  },
  {
    title: TITLES.PRICE_DIFFERENCE,
    dataIndex: TITLES.PRICE_DIFFERENCE,
    width: 120,

    align: 'center',
    key: '29',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }
  },
  {
    title: TITLES.PRICE_VS_MARKET,
    dataIndex: TITLES.PRICE_VS_MARKET,
    align: 'center',
    key: '21',
    width: 120,
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    dataIndex: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    align: 'center',
    key: '22',
    width: 180,

    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_WIZZ_AIR,
    dataIndex: TITLES.PRICE_VS_WIZZ_AIR,
    align: 'center',
    key: '23',
    width: 180,
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_EASY_JET,
    dataIndex: TITLES.PRICE_VS_EASY_JET,
    align: 'center',
    key: '24',
    width: 180,

    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.MARKET_PRICE_AVG,
    dataIndex: TITLES.MARKET_PRICE_AVG,
    align: 'center',
    width:100,
    key: '25',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    dataIndex: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    align: 'center',
    width:100,
    key: '26',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BLUE_AIR_PRICE_AVG,
    dataIndex: TITLES.BLUE_AIR_PRICE_AVG,
    align: 'center',
    width:100,

    key: '27',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.WIZZ_AIR_PRICE_AVG,
    dataIndex: TITLES.WIZZ_AIR_PRICE_AVG,
    align: 'center',
    width:100,
    key: '28',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.RYANAIR_PRICE_AVG,
    dataIndex: TITLES.RYANAIR_PRICE_AVG,
    align: 'center',
    width:100,

    key: '29',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.EASY_JET_PRICE_AVG,
    dataIndex: TITLES.EASY_JET_PRICE_AVG,
    align: 'center',
    width:100,

    key: '30',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
];

export const ContinentColumns: TableColumnsType<DataType> = [
  {
    title: AIRPORT_TITLES.DESTINATION_CONTINENT,
    dataIndex: AIRPORT_TITLES.DESTINATION_CONTINENT,
    key: '1',
    width: 110,
    align: 'center',
  },
  {
    title: TITLES.PRICE_DIFFERENCE,
    dataIndex: TITLES.PRICE_DIFFERENCE,
    align: 'center',
    key: '27',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }
  },
  {
    title: TITLES.PRICE_VS_MARKET,
    dataIndex: TITLES.PRICE_VS_MARKET,
    align: 'center',
    key: '21',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    dataIndex: TITLES.PRICE_VS_BRITISH_AIRWAYS,
    align: 'center',
    key: '22',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_WIZZ_AIR,
    dataIndex: TITLES.PRICE_VS_WIZZ_AIR,
    align: 'center',
    key: '23',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.PRICE_VS_EASY_JET,
    dataIndex: TITLES.PRICE_VS_EASY_JET,
    align: 'center',
    key: '24',
    render: (text, record) => {
      return renderWithIcon(text as string);
    },
  },
  {
    title: TITLES.MARKET_PRICE_AVG,
    dataIndex: TITLES.MARKET_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    dataIndex: TITLES.BRITIS_AIRWAYS_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.BLUE_AIR_PRICE_AVG,
    dataIndex: TITLES.BLUE_AIR_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.WIZZ_AIR_PRICE_AVG,
    dataIndex: TITLES.WIZZ_AIR_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.RYANAIR_PRICE_AVG,
    dataIndex: TITLES.RYANAIR_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
  {
    title: TITLES.EASY_JET_PRICE_AVG,
    dataIndex: TITLES.EASY_JET_PRICE_AVG,
    align: 'center',
    key: '24',render:(text, record) => {
      return text || <Tooltip title="Missing data">
          <ExclamationCircleOutlined />
        </Tooltip>
    }

  },
];

function convertToDate(dateStr: string) {
  // Split the date into month, day, and year
  const [month, day, year] = dateStr.split('/');

  // Convert the year to 4 digits
  const fullYear =
    year.length === 2
      ? parseInt(year) < 70
        ? '20' + year
        : '19' + year
      : year;

  // Return the date in "MM/DD/YYYY" format
  return new Date(`${month}/${day}/${fullYear}`);
}

function convertToMinutes(timeStr: string) {
  // Split the time string into hours and minutes
  const [hours, minutes] = timeStr.split('h').map((str) => str.trim());
  const totalMinutes =
    parseInt(hours) * 60 + parseInt(minutes.replace('m', ''));
  return totalMinutes;
}
